// Rider portrait of the dashboard, and of every rider in a standings table (riderPic.ts), as a photo job (photos.ts):
// cached, redone only when the outfit, colour or level change, the previous portrait standing in meanwhile. The
// rendering itself (three.js, the rider model) lives in portraitStudio.ts and loads on demand.
import { headwearOf, type Look } from '@gruvetto/contracts';
import { resolveLook } from '@gruvetto/creations';
import { photoKey, type PhotoJob } from './photos.js';

const VERSION = 12;

/**
 * The look the portrait is taken in, as a rider poses for the team photo: the road helmet comes off, so the haircut
 * shows, and so do the sunglasses, so the eyes are seen. A hat is part of the look and stays on.
 */
export function portraitLook(look: unknown): Partial<Look> {
  const l = (look && typeof look === 'object' ? look : {}) as Partial<Look>, r = resolveLook(l);
  const helmetOff = headwearOf(r.helmet) === 'road';
  return { ...l, ...(helmetOff ? { helmet: 'bare', wear: { ...l.wear, helmet: undefined } } : {}), body: { ...r.body, glasses: 'aucune' } };
}

/**
 * Portrait job for the photo queue; the key covers everything visible in it. `level` null: another rider, whose level
 * is not known, so the backdrop carries no number. The subject is the rider: their previous portrait stands in.
 */
export function portraitPhoto(look: unknown, color: string, level: number | null): PhotoJob {
  return { key: photoKey('portrait', VERSION, look, color, level), subject: `portrait:${photoKey(look, color)}`, run: async () => (await import('./portraitStudio.js')).render(portraitLook(look), color, level) };
}
